import { useEffect, useCallback } from 'react';
import { Board } from '../components/Board/Board';
import { ProblemCard } from '../components/ProblemCard/ProblemCard';
import { useProblem } from '../hooks/useProblem';
import type { HintArea, HintExact } from '../types';

export function ProblemPage() {
  const {
    problem, result, isLoading, hint, hintLevel, solutionPath,
    loadRandom, submitMove, requestHint, showSolution,
  } = useProblem();

  useEffect(() => {
    if (!problem) loadRandom();
  }, [problem, loadRandom]);

  const handleMove = useCallback((coord: string) => {
    submitMove(coord);
  }, [submitMove]);

  if (isLoading || !problem) {
    return (
      <div className="page-loading">
        <div className="spinner" />
        <p>Loading problem...</p>
      </div>
    );
  }

  const hintArea = hint && 'area' in hint ? (hint as HintArea).area : null;
  const hintCoord = hint && 'coord' in hint ? (hint as HintExact).coord : null;

  return (
    <div className="problem-page">
      <Board
        problem={problem}
        onMove={handleMove}
        disabled={!!result?.solved || !!solutionPath}
        opponentMove={result?.opponent_move}
        hintArea={hintArea}
        hintCoord={hintCoord}
        solutionPath={solutionPath}
      />
      <ProblemCard
        problem={problem}
        result={result}
        hintLevel={hintLevel}
        onHint={requestHint}
        onShowSolution={showSolution}
        onNext={() => loadRandom()}
      />
    </div>
  );
}
